module.exports = __webpack_public_path__ + "static/media/startimg.96b1c93c.png";